// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Dnjn","tabsBox":"styles_tabsBox__3MSzA","createButton":"styles_createButton__3HxUR"};